// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SplGrpAuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authState.pipe(
      take(1),
      map(authState => {
        const roles = authState.user?.roles?.map(r => r.toLowerCase()) || [];
        return roles.includes('closefriend') || roles.includes('admin');
      })
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authState.pipe(
      take(1),
      map(authState => {
        const roles = authState.user?.roles?.map(r => r.toLowerCase()) || [];
        return roles.includes('closefriend') || roles.includes('admin');
      })
    );
  }

  private get authState() {
    return this.authService.authState;
  }
}
